export default {
    title: "Plan List",
    add_plan_button: "Add plan",
    edit_button: "Edit",
    form: {
        name: "Plan name",
        description: "Description",
        billing_type: "Billing type",
        prepaid: "Prepaid",
        postpaid: "Postpaid",
        base_value: "Base value",
        incentivized_revenue_share: "% Incentivized revenue",
        retention_revenue_share: "% Retention revenue",
        pricetable_clients: "Client price table",
        pricetable_credits: "Credit price table",
        pricetable_extra_credits: "Extra credits price table",
        included_integrations: "Included integrations",
        price_per_integration: "Price per extra integration",
        included_branches: "Included branches",
        price_per_branch: "Price per branch",
        included_users: "Included users",
        price_per_user: "Price per user",
        included_users_per_branch: "Included users per branch",
        currency: "Currency",
        currency_brl: "BRL — Brazilian Real",
        currency_usd: "USD — US Dollar",
        one_invoice_per_branch_plus_base: "Generate one invoice per branch + main place base invoice",
        one_invoice_per_branch_plus_base_help: "When enabled, each branch will receive an invoice with its credit consumption and the main place will receive the base fee and fixed costs invoice.",
        main_branch: "Main Branch",
        select_main_branch: "Select the main branch...",
        main_branch_help: "The branch selected as Main will concentrate the base fee and fixed costs billing.",
        select_main_branch_warning: "Please select the Main Branch for the branch billing model.",
        readjustment: {
            title: "Price adjustment",
            percentage: "Adjustment percentage (%)",
            placeholder: "Enter the adjustment percentage",
            apply: "% Apply",
            help: "Applies percentage over base fee, contacts and credits.",
            success: "Adjustment applied! All values have been adjusted by {percentage}%.",
        },
        change_reason: {
            label: "Change reason",
            placeholder: "E.g. Upgrade due to user growth",
            required_alert: "Attention: Since changes were made, providing a reason is required.",
            required_validation: "Please provide the reason for the change before saving.",
        },
        no_changes_detected: "No changes detected.",
        discount_table: {
            title: "Discounts",
            add_button: "+ Add discount",
            discount_index: "Discount {0}",
            value: "Discount value",
            start_date: "Start date",
            end_date: "Discount valid until",
            description: "Description",
            description_placeholder: "Describe the reason or details of the discount...",
        },
        save: "Save",
        success_message: "Settings updated",
        price_table: {
            interval: "Interval",
            unit_value: "Unit value",
            add_button: "Add",
        },
    },
};
